import { useCopilotTool } from '@customerio/hydra-copilot/react';
import { cache, type InvalidateCacheEntry } from '@customerio/hydra-nav-state';
import { parseCioMutations, type CioResource } from '../approval/parse-cio-resources';

// Omit id for creates/dynamic ids (→ collection-wide invalidation); attach parent only for nested paths.
function entryFromResource(resource: CioResource): InvalidateCacheEntry {
  const entry: InvalidateCacheEntry = { type: resource.resourceType };
  if (resource.resourceId != null) {
    entry.id = resource.resourceId;
  }
  if (resource.parentType != null && resource.parentId != null) {
    entry.parentType = resource.parentType;
    entry.parentId = resource.parentId;
  }
  return entry;
}

export function invalidateCacheForCommand(command: string) {
  const entries = parseCioMutations(command).map(entryFromResource);
  if (entries.length > 0) {
    cache.invalidate(entries);
  }
}

// A real bash execution carries exit_code/stdout — delivered as a JSON string, an
// object, or a [marker, result] array. Approval/rejection markers ({ status }) don't,
// so a denied or not-yet-run mutation is skipped.
function bashExecuted(result: unknown): boolean {
  const items = Array.isArray(result) ? result : [result];
  for (const item of items) {
    let value: unknown = item;
    if (typeof value === 'string') {
      try {
        value = JSON.parse(value);
      } catch {
        continue;
      }
    }
    if (value != null && typeof value === 'object' && ('exit_code' in value || 'stdout' in value)) {
      return true;
    }
  }
  return false;
}

export function BashTool() {
  useCopilotTool({
    type: 'server',
    name: 'bash',
    handler({ args, response }) {
      if (response?.error != null || !bashExecuted(response?.result)) {
        return;
      }

      invalidateCacheForCommand(String(args.command));
    },
  });

  return null;
}
